import { connect } from 'react-redux';

import ForgotPasswordForm from './ForgotPasswordForm';
import * as duckActions from './duck';

import { IntlMessage } from '$HVUI';

const ForgotPassword = props => {
    const { forgotPasswordEmail } = props;
    return (
        <div>
            <h1 style={{ marginTop: '32px' }}>
                <IntlMessage
                    id="forgot-password.recover-my-password"
                    defaultMessage="Recover My Password"
                />
            </h1>
            <ForgotPasswordForm
                forgotPasswordEmail={forgotPasswordEmail}
                onSubmit={props.submitForgotPassword}
            />
        </div>
    );
};

export const mapStateToProps = (state, ownProps) => {
    return Object.assign(
        {},
        {
            forgotPasswordEmail: state.introduction.forgotPasswordEmail
        },
        ownProps
    );
};

export default connect(mapStateToProps, duckActions)(ForgotPassword);
